import { createContext } from "react";

import { type StreamCache } from "./cache";

export const OakStreamClientContext = createContext<StreamCache | null>(null);
